import { FiberManualRecord } from '@material-ui/icons';
import React from 'react';


export function Dot(props: {color: "active"|"inactive"|string}) {
  const colorMap = {
    active: "#a3f48a",
    inactive: "#e9ecef",
  } as {[key: string]: string}
  return (
    <FiberManualRecord
      style={{
        fill: props.color in colorMap ? colorMap[props.color] : props.color,
        fontSize: 16,
        marginBottom: 4,
        marginRight: 4,
      }}
      fontSize="small"
    />
  );
}